export default __webpack_public_path__ + "79fa64f27e644b6c56581058bb68100a.png";